import React, { useContext } from "react";
import { MedicInformationContext } from "../../context/MedicInformationContextProvider";
import {
  HeartIcon,
  cardMedicamentos,
  cardMedicamentosContent,
  h5MedicamentosStyles,
  pMedicamentosStyles,
} from "../CustomStyle";
import { tratamientoIcon } from "../imagepath";

const PatientesTreatment = () => {
  const { afiliadoMedicamentos } = useContext(MedicInformationContext);

  return (
    <div className="card-body">
      <div className="heading">
        <div className="heading-detail">
          <img
            src={tratamientoIcon}
            width="20px"
            height="20px"
            color="#004988"
          />
          <h4>Tratamiento farmacológico</h4>
        </div>
      </div>
      <div className="body-data">
        {afiliadoMedicamentos.map((medicamento, index) => (
          <div key={index} style={cardMedicamentos}>
            <div style={cardMedicamentosContent}>
              <HeartIcon />
              <h5 style={h5MedicamentosStyles}>{medicamento.medicamento}</h5>
            </div>
            <p style={pMedicamentosStyles}>
              Fecha de marca: {medicamento.autorizacion}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PatientesTreatment;
